<template>
  <div class="bidder-page">
    <div class="page-header">
      <h2 class="page-title">招标文件详情</h2>
      <el-button type="primary" icon="el-icon-back" @click="handleBack">返回</el-button>
    </div>
    <div class="content-wrap">
      <!-- 基本信息 -->
      <div class="section-block">
        <div class="section-title">基本信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件编号：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsCode || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件名称：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsName || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件类型：</span>
              <span class="value">{{ getDocumentTypeText(detailData.documentType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件编制状态：</span>
              <span class="value">{{ getDocumentStatusText(detailData.documentPreparationStatus) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidOpeningTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">解密截止时间：</span>
              <span class="value">{{ detailData.decryptionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">创建时间：</span>
              <span class="value">{{ detailData.createTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">质疑提出截止时间：</span>
              <span class="value">{{ (detailData.bidSectionConfig && detailData.bidSectionConfig.questionDeadline) || '-' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 标段信息列表 -->
      <div class="section-block" v-if="detailData.bidSectionList && detailData.bidSectionList.length > 0">
        <div class="section-title">标段信息</div>
        <el-table :data="detailData.bidSectionList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="标段编号" prop="bidSectionCode" min-width="180"></el-table-column>
          <el-table-column label="标段名称" prop="bidSectionName" min-width="300"></el-table-column>
        </el-table>
      </div>

      <!-- 开标一览表（只读） -->
      <div class="section-block" v-if="detailData.bidOpeningLists && detailData.bidOpeningLists.length > 0">
        <div class="section-title">开标一览表</div>
        <el-table :data="detailData.bidOpeningLists" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="项目名称" prop="itemName" min-width="150"></el-table-column>
          <el-table-column label="填报内容类型" width="140" align="center">
            <template slot-scope="scope">
              {{ getItemValueTypeText(scope.row.itemValueType) }}
            </template>
          </el-table-column>
          <el-table-column label="单位" width="100" align="center">
            <template slot-scope="scope">
              {{ getItemUnitText(scope.row.itemUnit) }}
            </template>
          </el-table-column>
          <el-table-column label="填报说明" prop="itemInstructions" min-width="200"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
        </el-table>
      </div>

      <!-- 文件目录（只读树形展示） -->
      <div class="section-block" v-if="detailData.catalogues && detailData.catalogues.length > 0">
        <div class="section-title">文件目录</div>
        <el-tree
          :data="detailData.catalogues"
          :props="treeProps"
          node-key="strId"
          default-expand-all
          class="catalogue-tree"
        >
          <span class="custom-tree-node" slot-scope="{ data }">
            <span>
              <i class="el-icon-folder-opened" style="color: #409EFF; margin-right: 5px;"></i>
              {{ data.catalogueName }}
            </span>
            <span style="color: #999; font-size: 12px; margin-left: 10px;">
              {{ data.catalogueDescription }}
            </span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { getBidInvitationDocumentsDetail } from '@/api/modules/agent'

export default {
  name: 'BidDocumentDetail',
  data() {
    return {
      bidInvitationDocumentsCode: '',
      detailData: {},
      treeProps: {
        children: 'children',
        label: 'catalogueName'
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
      if (!this.bidInvitationDocumentsCode) {
        this.$message.error('缺少招标文件编号参数')
        this.$router.go(-1)
        return
      }
      this.getBidInvitationDocumentsDetail()
    },

    async getBidInvitationDocumentsDetail() {
      try {
        const res = await getBidInvitationDocumentsDetail({
          bidInvitationDocumentsCode: this.bidInvitationDocumentsCode
        })
        if (res.code === 200) {
          this.detailData = res.data || {}
        } else {
          this.$message.error(res.msg || '获取招标文件详情失败')
        }
      } catch (error) {
        console.error('获取招标文件详情失败:', error)
        this.$message.error('获取招标文件详情失败，请重试')
      }
    },

    getDocumentTypeText(type) {
      const typeMap = { 1: '文件', 2: '补遗书', 3: '澄清文件' }
      return typeMap[type] || '-'
    },

    getDocumentStatusText(status) {
      const statusMap = { 0: '未编制', 1: '已编制' }
      return statusMap[status] || '-'
    },

    getItemValueTypeText(valueType) {
      const valueTypeMap = { 0: '任意文本', 1: '纯数字' }
      return valueTypeMap[valueType] || '-'
    },

    getItemUnitText(unit) {
      const unitMap = { 0: '元', 1: '万元', 2: '%' }
      return unitMap[unit] || '-'
    },

    handleBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.section-block {
  margin-bottom: 30px;
  padding: 20px;
  background: #fafafa;
  border-radius: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f4f7;
}

.detail-row {
  .field {
    display: flex;
    padding: 12px 0;
    line-height: 1.6;

    .label {
      min-width: 180px;
      color: #666;
      font-weight: 500;
    }

    .value {
      flex: 1;
      color: #333;
      word-break: break-all;
    }
  }
}

.catalogue-tree {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #EBEEF5;

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}

::v-deep .el-table {
  margin-top: 10px;

  th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
  }

  .el-table__empty-text {
    color: #999;
  }
}

::v-deep .el-tree-node__content {
  height: 36px;
  line-height: 36px;
}
</style>
